import React from "react";
import Frame from "../../../../Frame/index.js";
import { useFlightCardLuggageController } from "./useFlightCardLuggage.controller.js";
import { Stack, Text } from "@bookingcom/bui-react";
import { CardAncillariesPopover } from "@flights/search-ui";
import { useSplitBoundsCondition } from "../../../../../../utils/experiments/funnel/flights_split_bounds_us.js";
import { formatFareName } from "@flights/branded-fares";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
export const FlightCardLuggageDesktop = ({ flight, brandedFareInfo, buttonAlignment, brandedFareInfoAlignment = "end", iconsAlignment = "end" }) => {
    const i18n = useI18n();
    const { isSplitBounds } = useSplitBoundsCondition();
    const { luggageList } = useFlightCardLuggageController(flight);
    if (luggageList.length === 0) {
        return null;
    }
    return (React.createElement(Stack, { gap: 0.5 },
        brandedFareInfo ? (React.createElement(BrandedFareDescription, { brandedFareInfo: brandedFareInfo, align: brandedFareInfoAlignment })) : null,
        React.createElement(CardAncillariesPopover, { titleText: isSplitBounds ? undefined : i18n.trans(t("flights_sr_hover_included_baggage")), ancillaries: luggageList, align: iconsAlignment, buttonAlignment: buttonAlignment })));
};
export const BrandedFareDescription = ({ brandedFareInfo, align }) => {
    const { fareName } = brandedFareInfo;
    return (React.createElement(Frame, null,
        React.createElement(Text, { variant: "small_1", align: align, color: "neutral" }, formatFareName(fareName))));
};
